import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useRegisterComponent } from '../../../orchestrator';
import { useButtonClickedEvent } from '../../../../utilities/analytics/analytics-web-client';
import messages from '../messages/content';
import { pageId } from '../constants';
import Link from '@atlaskit/link';

type Props = {
  /**
   * Whether the passkeys section is shown on the page. When false, this component renders null.
   * Cobranders should derive this from the `hasPasskeys` value returned by `useHasPasskeys` and
   * pass `!hasPasskeys` here.
   */
  isPasskeyShown: boolean;
};

/**
 * Renders the "Learn more about passkeys" external link if `isPasskeyShown` is true. Otherwise, renders nothing.
 * The component must always be used even if `isPasskeyShown` is false to ensure that the component is registered.
 */
export const PasskeysMoreInfoLink = ({ isPasskeyShown }: Props) => {
  useRegisterComponent(PasskeysMoreInfoLink.name);

  const trackPasskeysLearnMoreLinkClicked = useButtonClickedEvent(
    pageId,
    'PasskeysPromoteLearnMore'
  );

  if (!isPasskeyShown) {
    return null;
  }

  return (
    <Link
      id="passkeys-promote-learn-more"
      onClick={trackPasskeysLearnMoreLinkClicked}
      href="https://support.atlassian.com/atlassian-account/docs/access-your-atlassian-account-with-a-passkey/"
      target="_blank"
      rel="noopener noreferrer">
      <FormattedMessage {...messages.promotePasskeysLearnMore} />
    </Link>
  );
};
